import { useEffect, useState } from 'react';
import { Routes } from '../../../common';
import { UserSettings } from './UserSettings';
import { Icon, IconType } from '@repo/ui/components';
import { cn } from 'types';
import { IApiEmployee } from 'next-common';
import { useAppSelector } from '../../../store/hooks';
import { selectEmployee } from '../../../store/selectors';

export const SalesPerson = () => {
  const employee: IApiEmployee = useAppSelector(selectEmployee);
  const [open, setOpen] = useState<boolean>(false);

  const salesPersonName =
    employee?.firstName && employee?.lastName ? `${employee.firstName} ${employee.lastName}` : null;

  const setModal = (value: boolean) => {
    setOpen(value);
  };
  //Each time we need to know the route so we can enable or disable the button. That`s why useEffect needs to run on every render
  const [isMarginerPage, setIsMarginerPage] = useState<boolean>(false);
  useEffect(() => {
    setIsMarginerPage(window.location.pathname === Routes.getMarginsPage());
  }, []);

  return (
    <div className="flex place-items-center gap-2 pl-4 py-3">
      <Icon
        icon={IconType.NewNextUserSettings}
        aria-hidden
        height={24}
        width={24}
        className="cursor-pointer"
        fill="var(--color-white)"
      />
      <button
        className={cn(
          'cursor-pointer text-base/[175%] font-semibold',
          salesPersonName ? 'text-white' : 'text-oldSilver'
        )}
        onClick={() => setModal(true)}
      >
        {salesPersonName ?? 'Ukjent selger'}
      </button>
      {open && <UserSettings employee={employee} setModal={setModal} isMarginerPage={isMarginerPage} />}
    </div>
  );
};
